import React from 'react';
import Modal from '@components/Modal';
import { I18n } from 'react-redux-i18n';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import * as yup from 'yup';
import { nameRule, passwordRule } from './validation';

const schema = yup.object().shape({
  name: nameRule,
  password: passwordRule,
});

const LinkChild = ({ show, close, onSave }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    reValidateMode: 'onChange',
    resolver: yupResolver(schema),
  });

  const onSubmit = data => onSave(data);

  return (
    <Modal
      show={show}
      close={close}
      hideClose={true}
      dialogClassName="with-robot-head"
      id="modal-editProfile"
    >
      <div className="row modal-robot-body text-center ">
        <div className="robot-head">
          <img
            src={require('../../../assets/images/robot-green-happy-head.svg')}
            alt="progkids-green-robot"
          />
        </div>
        <br />

        <form
          onSubmit={handleSubmit(onSubmit)}
          className="col-xs-12 form-group"
        >
          <div className={`form-group has-success`}>
            <span>{I18n.t('settings.personal.game.title')}</span>
            <input
              type="text"
              className="form-control"
              autoComplete="username"
              {...register('name')}
            />
            <span className="help-block">
              {errors.name && errors.name.message}
            </span>
          </div>

          <div className={`form-group has-success`}>
            <span>{I18n.t('settings.personal.password.title')}</span>
            <input
              type="password"
              className="form-control"
              {...register('password')}
            />
            <span className="help-block">
              {errors.password && errors.password.message}
            </span>
          </div>
          <button className="btn btn-green-small text-uppercase">
            {I18n.t('settings.personal.children.linkAccount')}
          </button>
        </form>
      </div>
    </Modal>
  );
};

export default LinkChild;
